import axios from 'axios';

const API_BASE = 'https://formmaker-api.altynlogistics.com/api';

export const forgetPasswordRequest = async (data) => {
    return axios.post(`${API_BASE}/password/forgot`, data, {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
    });
};

export const resetPasswordRequest = async (data) => {
    return axios.post(`${API_BASE}/password/reset`, data, {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
    });
};

export const fetchCountries = async () => {
    return axios.get(`${API_BASE}/countries`);
};
